/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Status_PendingInputs */

const cs_chat_status_pending = /** @type {(inputs: Chat_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odesílání`)
};

const en_chat_status_pending = /** @type {(inputs: Chat_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Chat_Status_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_status_pending = /** @type {((inputs?: Chat_Status_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Status_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_status_pending(inputs)
	return cs_chat_status_pending(inputs)
});